import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import {
  createBusiness,
  searchCompany,
  createBusinessEntities,
  SEND_REPORT,
  DOWNLOAD_CREDIT_REPORT_PDF,
} from './add-new-wizzard.types';

import {
  requestCreateBusinessFailure,
  requestCreateBusinessSuccess,
  requestCreateBusinessEntitiesSuccess,
  requestCreateBusinessEntitiesFailure,
  requestSearchCompanyFailure,
  requestSearchCompanySuccess,
} from './reducer';

const logger = new Logger('Saga:Monitor:NewClientWizzard');

export function* requestCreateBusiness(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const promise = action && action[1];

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.create_business_entity'),
      action[0],
    );

    promise && promise.resolve(response.data);
    requestCreateBusinessEntitiesSuccess(response.data);
  } catch (error) {
    logger.error('Failed to create business entity with the following error', error);
    promise && promise.reject(error);
    requestCreateBusinessEntitiesFailure(error);
  }
}

export function* requestCreateBusinessEntities(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const promise = action && action[1];

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.platform.entities'),
      action[0],
    );

    promise && promise.resolve(response.data);
    requestCreateBusinessSuccess(response.data);
  } catch (error) {
    logger.error('Failed to create business entity with the following error', error);
    promise && promise.reject(error);
    requestCreateBusinessFailure(error);
  }
}

export function* requestCreditReport(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.funding_profile_send_company_report'),
      { company_number: action.companyNumber },
    );

    action.promise && action.promise.resolve(response.data);
  } catch (error) {
    logger.error('Failed to request credit report with the following error', error);
    action.promise && action.promise.reject(error);
  }
}

export function* requestDownloadCreditReportPdf(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.download_credit_report_pdf', {
        companyNumber: action.companyNumber,
      }),
      {
        headers: {
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      },
    );

    action.promise && action.promise.resolve(response.data);
  } catch (error) {
    logger.error('Failed to request credit report with the following error', error);
    action.promise && action.promise.reject(error);
  }
}

export function* requestSearchCompany(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const promise = action && action[1];

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.funding_search_company_search', {
        companyInfo: encodeURIComponent(action[0]),
      }),
    );

    const withIds = response.data.map((c, idx) => ({ ...c, id: +idx + 1 }));
    promise && promise.resolve();
    yield put(requestSearchCompanySuccess(withIds));
  } catch (error) {
    logger.error('Failed to request companies with the following error', error);
    promise && promise.reject(error);
    yield put(requestSearchCompanyFailure(error));
  }
}

export default function* wizzardSaga() {
  return yield all([
    takeLatest(createBusiness.request, requestCreateBusiness),
    takeLatest(createBusinessEntities.request, requestCreateBusinessEntities),
    takeLatest(searchCompany.request, requestSearchCompany),
    takeLatest(SEND_REPORT, requestCreditReport),
    takeLatest(DOWNLOAD_CREDIT_REPORT_PDF, requestDownloadCreditReportPdf),
  ]);
}
